module.exports = __webpack_public_path__ + "static/media/Pin_Job_JumpStart.93687fc1.svg";